import { render, staticRenderFns } from "./SimTask.vue?vue&type=template&id=7b2bc1c2&scoped=true"
import script from "./SimTask.vue?vue&type=script&lang=js"
export * from "./SimTask.vue?vue&type=script&lang=js"
import style0 from "./SimTask.vue?vue&type=style&index=0&id=7b2bc1c2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bc1c2",
  null
  
)

export default component.exports